/**
 * @desc 校验验证码
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 用户编码 */
  code: string;
  /** 验证码 */
  verificationCode: string;
}

export function request(params: Params): Promise<defs.StandardReturn<boolean>> {
  return defHttp.get({
    url: '/web/user/checkVerification',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<boolean>> {
  return defHttp.get({
    url: '/mock/web/user/checkVerification',

    params,
  });
}
